import React from 'react';
import Loadable from 'react-loadable';
import Spinner from '../../../Spinner/Spinner';

const HTOLoadable = Loadable({
    loader: () => import(/* webpackChunkName: 'hto-app' */ './HTO').then(module => module.default),
    loading: () => <Spinner />
});

export default HTOLoadable;
